import { render, staticRenderFns } from "./UserEditPasswordTab.vue?vue&type=template&id=335a3475&"
import script from "./UserEditPasswordTab.vue?vue&type=script&lang=ts&"
export * from "./UserEditPasswordTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports